import { LocatorEvent, PinClickEvent, CardClickEvent, PinHoverEvent } from './Events.js';
import { GoogleMapsEnterprise } from 'js/components/Maps/GoogleMapsEnterprise.js';
import { Maps } from 'js/components/Maps/index.js';

export class SearchMap extends GoogleMapsEnterprise {
  static initClass() {
    Maps.FactoryForProvider.Google = (data) => new this(data);
    this.instances = [];
    this.providerLoaded = false;
    this.className = "Yext.Maps.SearchMap";
    this.breakPoint = 992;
    this.pinClickCardToTop = true;
    this.pinHoverCardToTop = false;
    this.disablePinHover = false;
  }

  mapOffset() {
    let left = 0;
    let searchcontent = document.querySelector('.search-content-container');
    if ((searchcontent != null) && (window.innerWidth >= this.constructor.breakPoint)) {
      left = searchcontent.offsetLeft + searchcontent.offsetWidth;
    }
    return {
      top: this.BUFFER,
      bottom: this.BUFFER,
      left,
      right: this.BUFFER
    };
  }

  svgPin(label, backgroundColor, textColor) {
    return `
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="21" viewBox="0 0 32 42" id="js-loc-map-pin-svg">
        <defs>
            <radialGradient id="a" cx="48.708%" fx="48.708%" fy="50%" gradientTransform="matrix(0 1 -.90902 0 .942 .013)">
                <stop offset="0%" stop-opacity=".5"/>
                <stop offset="100%" stop-opacity=".15"/>
            </radialGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
            <ellipse cx="16.5" cy="39.2" fill="url(#a)" rx="12.5" ry="2.8"/>
            <path fill="#CD2028" d="M0 14.933C0 25.611 16 39.2 16 39.2s16-13.59 16-24.267C32 6.925 24.914 0 16 0S0 6.925 0 14.933z"/>
            <path fill="#FFF" d="M22.783 8.403c-.184.526-.366 1.054-.548 1.58-.337 1.08-.797 2.638-1.45 5.387l-.42 1.813c-.052.228-.104.462-.157.704-.177.798-.501 2.038-.605 2.487-.16.711-.35 1.129-1.087 1.354 0 0-.386.13-.85.068-1.005-.137-1.058-.922-1.23-1.555-.264-.968-.555-3.34-.601-4.717l-.013-.422-.008-.14a.468.468 0 0 0-.015-.125c-.01-.043-.04-.057-.087-.044-.048.011-.083.065-.156.263-.12.39-.345 1.142-.516 1.814-.3 1.13-.65 2.432-.803 3.166l-.52 2.064c-.136.619-.769 1.015-1.187 1.126-.458.119-.725.14-1.074.058-.468-.112-.744-.686-.885-1.204a8.271 8.271 0 0 1-.288-1.484c-.118-1.313-.172-2.233-.146-3.56.028-1.537.163-3.785.255-5.032l.043-1.24c-.003-.462-.033-.747-.092-.953-.052-.173-.117-.272-.24-.443-.042-.059-.085-.098-.097-.138-.074-.267.528-.76 1.336-.947.501-.115.937-.141 1.298.162.23.251.268.496.26 1.006-.005.17-.026.425-.045.668-.057.8-.257 2.2-.313 3-.1 1.11-.203 2.35-.22 3.491-.01.56-.007 1.623.037 1.79.024.082.064.138.135.12.07-.022.106-.076.21-.35l.084-.338.084-.336s.462-1.626.853-2.953c.421-1.28.84-2.601 1.12-3.345.415-1.097.624-1.9 1.355-2.087.732-.187 1.407.122 1.55.649.073.274.076.445.054 1.513-.035 1.869.098 3.343.156 4.767.041.62.098 1.102.16 1.334.03.106.087.138.136.126.094-.021.123-.094.18-.356l.074-.376c.165-.835.33-1.67.497-2.505.384-1.83.655-2.911 1.134-4.608.568-2.016.993-2.93 1.727-3.095.693-.155 1.087.397 1.13.949.015.186-.07.596-.215.894"/>
        </g>
      </svg>
    `;
  }
  iconImage(location, i) {
    return `data:image/svg+xml;charset=utf8,${encodeURIComponent(this.svgPin())}`;
  }

  preparePin(i, loc, m) {

    let link = document.createElement('a');
    link.setAttribute('href', loc.get_directions_url);
    link.setAttribute('target', '_blank');
    link.setAttribute('rel', 'nofollow noopener noreferrer');
    link.setAttribute('data-ya-track', 'nap_mappin');
    link.id = 'js-loc-map-pin';

    let icon = this.iconImage(loc, i);
    this.validatePinIcon(icon);
    let pin = new google.maps.Marker({
      position: new google.maps.LatLng(loc.latitude, loc.longitude),
      icon,
      map: m,
      zIndex: 0,
      optimized: false // For IE <= 11 compat
    });

    pin.addListener('click', () => {
      link.click();
    });
    pin.isDefault = true;

    return pin;
  }

  clickHandler(loc, pin, index, map) {

    let target = `js-yl-${loc.id}`;
    document.dispatchEvent(new PinClickEvent(target));

    if (this.infowindow != null) {
      this.infowindow.close();
      this.infowindow = null;
    }

    let infoContentTemplate = document.querySelector(`#${target} > .js-infowindow`);
    if (infoContentTemplate == null) { return; }
    if (window.innerWidth >= this.constructor.breakPoint) {
      this.infowindow = new google.maps.InfoWindow({
        content: infoContentTemplate.innerText
      });
      this.infowindow.open(map, pin);
    } else {
      let mobileInfo = document.getElementById('js-mobile-info');
      mobileInfo.innerHTML = infoContentTemplate.innerText;
      map.panTo(pin.position);
      window.setTimeout((function() {
        let overlay = document.getElementById('js-overlay');
        overlay.classList.add('is-active');
        return overlay.classList.add('in');
      }), 20);
    }

  }

  hoverHandler(active, loc, pin, index, map) {

    let target = `js-yl-${loc.id}`;
    document.dispatchEvent(new PinHoverEvent(target, active));
  }

  iconImage(loc, i, backgroundColor, textColor) {
    if (backgroundColor == null) { backgroundColor = 'black'; }
    if (textColor == null) { textColor = 'white'; }
    let iconUrl;

    if (loc.baconPin) {
      iconUrl = Yext.BaseUrl + 'assets/images/bacon-pin.png';
    } else {
      iconUrl = `data:image/svg+xml;charset=utf8,${encodeURIComponent(this.svgPin(i+1, backgroundColor, textColor))}`;
    }
    return {
      url: iconUrl,
      scaledSize: new google.maps.Size(48,63)
    };
  }
}
SearchMap.initClass();

let registerClickHandlers = function() {
  let results = document.getElementsByClassName('js-location-result');
  for (let result of Array.from(results)) {
    result.addEventListener('click', function() {
      if (!(window.innerWidth >= SearchMap.breakPoint)) { return; }
      document.dispatchEvent(new CardClickEvent(this.getAttribute('id')));
    });
    result.addEventListener('mouseenter', function() {
      if (!(window.innerWidth >= SearchMap.breakPoint)) { return; }
      document.dispatchEvent(new PinHoverEvent(this.getAttribute('id')));
    });
  }

  document.addEventListener(PinClickEvent.eventTypeName, function(e) {

    let id = e.detail.yextId;
    if (id == null) { return; }
    document.getElementById(id).classList.add('is-active');
    let toRemove = document.querySelectorAll(`.js-location-result.is-active:not(#${id})`);
    for (let toChange of Array.from(toRemove)) {
      toChange.classList.remove('is-active');
    }
    if (SearchMap.pinClickCardToTop) {
      window.location.hash = `#${id}`;
    }
  });

  document.addEventListener(CardClickEvent.eventTypeName, function(e) {

    let id = e.detail.yextId;
    if (id == null) { return; }
    document.getElementById(id).classList.toggle('is-active');
    let toRemove = document.querySelectorAll(`.js-location-result.is-active:not(#${id})`);
    for (let toChange of Array.from(toRemove)) {
      toChange.classList.remove('is-active');
    }
  });

  document.addEventListener(PinHoverEvent.eventTypeName, function(e) {

    let id = e.detail.yextId;
    if (id == null) { return; }
    document.getElementById(id).classList.add('is-active');
    let toRemove = document.querySelectorAll(`.js-location-result.is-active:not(#${id})`);
    for (let toChange of Array.from(toRemove)) {
      toChange.classList.remove('is-active');
    }
    if (SearchMap.pinHoverCardToTop) {
      window.location.hash = `#${id}`;
    }
  });
};

let registerMapToggling = function() {
  let buttons = document.querySelectorAll('.js-result-toggle');
  for (var button of Array.from(buttons)) {
    button.addEventListener('click', function() {
      document.body.classList.toggle('map-visible');
      document.dispatchEvent(new Event('toggle-map'));
    });
  }

  document.addEventListener('toggle-map', function() {
    for (button of Array.from(buttons)) {
      let disabled = button.getAttribute('disabled');
      if (disabled != null) { button.removeAttribute('disabled'); }
      if ((disabled == null)) { button.setAttribute('disabled', ''); }
    }
  });
};

let setupOverlayAnimation = function() {
  let overlay = document.getElementById('js-overlay');
  overlay.addEventListener('click', function(e) {
    if (e.target !== this) { return; }
    return this.classList.add('out');
  });

  document.addEventListener('toggle-map', () => overlay.classList.add('out'));

  let listener = function(e){
    if (e.type !=="animationend") { return; }
    switch (e.animationName) {
      case "overlay-in":
        overlay.classList.add('in-finished');
        overlay.classList.remove('in');
        break;
      case "overlay-out":
        overlay.classList.remove('is-active');
        overlay.classList.remove('in-finished');
        overlay.classList.remove('out');
        break;
    }
  };

  return overlay.addEventListener('animationend', listener, false);
};

export const MapSetup = () => {
  registerClickHandlers();
  registerMapToggling();
  setupOverlayAnimation();
}
